<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 style="padding: 2%;">
        <v-card color="primary" dark>
          <v-card-title>
            <v-icon large left>credit_card</v-icon>
            <span class="title font-weight-light">Current Plan</span>
            <v-spacer></v-spacer>
            <v-chip v-if="!isActive" class="ma-2" color="#ee5253" text-color="white">INACTIVE</v-chip>

            <v-chip
              class="ma-2"
              color="cyan"
              text-color="white"
            >{{ $store.getters.company.plan.cycle.toUpperCase() }}</v-chip>
          </v-card-title>
          <v-container fill-height>
            <v-layout justify-center>
              <div class="text-xs-center">
                <strong class="display-1 font-weight-regular mr-4">{{ currentPrice }}</strong>
              </div>
            </v-layout>
          </v-container>
          <v-container fill-height>
            <v-layout>
              <v-list-item class="grow">
                <v-list-item-avatar color="green">
                  <v-icon dark>mdi-account-circle</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>User Limit</v-list-item-title>
                </v-list-item-content>

                <v-row align="center" justify="end">
                  <span class="subheading customBorder">
                    {{
                    $store.getters.company.plan.userLimit
                    }}
                  </span>
                </v-row>
              </v-list-item>
            </v-layout>
          </v-container>

          <v-container fill-height>
            <v-layout>
              <v-list-item class="grow">
                <v-list-item-avatar color="green">
                  <v-icon dark>calendar_today</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>Expiry</v-list-item-title>
                </v-list-item-content>

                <v-list-item-content class="customCenter">
                  <v-list-item-title class="customBorder">
                    {{
                    $store.getters.company.plan.expiryDate | moment("llll")
                    }}
                  </v-list-item-title>
                </v-list-item-content>

                <!-- <v-row
                        align="center"
                        justify="end"
                      >
                        <span class="subheading">{{$store.getters.company.plan.expiryDate | moment('llll') 
                          }}</span>
                </v-row>-->
              </v-list-item>
            </v-layout>
          </v-container>

          <v-container v-if="isActive" fill-height>
            <v-layout justify-center>
              <div class="text-xs-center">
                <div class="d-flex justify-center">
                  <v-btn
                    v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'"
                    :disabled="afterUpdate"
                    @click.native="cancelSubscription"
                    color="white"
                    style="color:#4F5050;"
                  >Cancel</v-btn>
                </div>
              </div>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm12 md12 style="padding: 2%;">
        <v-card>
          <v-card-title>
            <v-icon large left>credit_card</v-icon>
            <span v-if="isActive" class="title font-weight-light">Change Plan</span>
            <span v-else class="title font-weight-light">Subscribe</span>

            <v-spacer></v-spacer>

            <!-- <segmented-control
                    :options="planCurrencyType"
                    label="label"
                    value="value"
                    color="#fff"
                    active-color="#333"
                    class="curFlex"
                    style="border: 2px solid rgb(51, 51, 51)!important;"
                    :multiple="false"
                    @select="onSelectSegmentCurrency"
                    :defaultSelected="{ value: 'USD', label: 'USD' }"
            />-->
          </v-card-title>

          <v-container fill-height>
            <v-layout justify-center>
              <img :src="require('@/assets/clip.png')" style="max-height:150px" />
            </v-layout>
          </v-container>

          <v-container fill-height>
            <v-layout justify-center>
              <div class="text-xs-center">
                <strong class="display-1 font-weight-bold mr-4">

                  <span v-if="discountedPrice == ''">

                  <div align="center">
                  
                  <span v-if="planCurrency == 'INR'">₹</span><span v-else>$</span>
                  
                  <span v-if="discountedPrice == ''">{{ planPrice }}</span>

                  </div>

                  <div v-if="planCurrency == 'INR'" style="font-size: 10px;" align="center">* 18% GST excluded ( ₹{{gstPrice}} )</div>

                  </span>


                  <span v-else>

                  <div align="center">
                  
                  <span v-if="planCurrency == 'INR'" style="">₹</span><span v-else style="">$</span>
                  
                  <span style="background: linear-gradient(to left top, transparent 45.5%, currentColor 47.5%, currentColor 52.5%, transparent 54.5%);">{{ planPrice }}</span>

                  </div>

                  <div align="center" style="padding-top: 4%;"><span v-if="planCurrency == 'INR'">₹</span><span v-else>$</span>
                  
                  <span v-if="discountedPrice != ''">{{ discountedPrice }}</span>
                  </div>

                   <div v-if="planCurrency == 'INR'" style="font-size: 10px;" align="center">* 18% GST excluded ( ₹{{gstPrice}} )</div>

                  </span>


              
                  
                </strong>
              </div>
            </v-layout>
          </v-container>

          <v-container fill-height>
            <v-layout justify-center>
              <segmented-control
                :options="planCycleType"
                :multiple="false"
                @select="onSelectSegment"
                :defaultSelected="{ value: 'Monthly', label: 'Monthly' }"
                label="label"
                value="value"
                color="#fff"
                active-color="#333"
                style="border: 2px solid rgb(51, 51, 51)!important;"
              />
            </v-layout>
          </v-container>

          <v-container fill-height>
            <v-layout row wrap style="padding-left: 4%;padding-right:4%; ">
              <h5
                class="title font-weight-light"
                style="padding-top: 12px;padding-right: 30px;"
              >No Of Members</h5>

              <v-flex>
                <v-text-field
                  v-model="numberOfMembers"
                  @change="changePrice"
                  class="mt-0"
                  hide-details
                  single-line
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container fill-height>
            <v-layout justify-center>
              <div class="text-xs-center">
                <div class="d-flex justify-center">
                  <v-btn
                    v-if="isActive"
                    :disabled="afterUpdate"
                    @click.native="pay"
                    color="primary"
                    class="company-save-btn"
                    large
                  >Update</v-btn>

                  <v-btn
                    v-else
                    :disabled="afterUpdate"
                    @click.native="pay"
                    color="primary"
                    class="company-save-btn"
                    large
                  >Pay</v-btn>
                </div>
              </div>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters, mapState } from "vuex";
import SegmentedControl from "vue-segmented-control";

import canSee from "@/utilities/canSee";
import fb from "@/utilities/firebase";
var logo = require("@/assets/logo-payment.png");
export default {
  components: {
    SegmentedControl
  },
  data() {
    return {
      gstPrice: "",
      discountedPrice: "",
      afterUpdate: false,
      planName: "",
      planExpiry: "",
      planUserLimit: "",
      planModule: [],
      min: 1,
      max: 1000,
      // numberOfMembers1: '10',
      numberOfMembers: "10",
      ftPlan: true,
      rftPlan: true,
      formsPlan: true,
      securityPlan: true,
      planCycleType: [
        { label: "Monthly", value: "Monthly" },
        { label: "Yearly", value: "Yearly" }
      ],
      planCurrencyType: [
        { label: "USD", value: "USD" },
        { label: "INR", value: "INR" }
      ],
      planCycle: "",
      planCurrency: "",
      planPrice: 0,
      ftPlanPrice: 0,
      rftPlanPrice: 0,
      formsPlanPrice: 0,
      securityPlanPrice: 0,
      planCycleMonth: 1,
      planPriceFinal: 0,
      companyData: {}
    };
  },
  created() {
    this.$store.dispatch("getCompany");

    this.planName = this.$store.getters.company.plan.name;

    this.planExpiry = moment(
      this.$store.getters.company.plan.expiryDate
    ).format("YYYY-MM-DD");

    this.planPriceFinal = this.$store.getters.company.plan.amountPerMonth || 0;

    this.planUserLimit = this.$store.getters.company.plan.userLimit;

    this.planModule = this.$store.getters.company.plan.module;

    this.companyData = this.$store.getters.company;

    console.log("country", this.companyData);

    this.planCycle = this.changePrice();

    this.onSelectSegmentCurrency();
  },
  computed: {
    ...mapGetters(["razorkey"]),
    currentPrice() {
      if (this.$store.getters.company.plan.externalPlanDetails) {
        return (
          Number(
            this.$store.getters.company.plan.externalPlanDetails.item
              .unit_amount
          ) / 100
        );
      } else {
        return "FREE";
      }
    },
    isActive() {
      return this.$store.getters.company.plan.active;
    }
  },

  methods: {
    onSelectSegment(optionsSelected) {
      var self = this;

      if (optionsSelected[0].value == "Monthly") {
        self.planCycle = "Monthly";
      } else {
        self.planCycle = "Yearly";
      }

      self.changePrice();
    },
    onSelectSegmentCurrency() {
      var self = this;

      if (this.companyData.country == "India") {
        self.planCurrency = "INR";
      } else {
        self.planCurrency = "USD";
      }

      self.changePrice();
    },
    changePrice() {
      const userCount = Number(this.numberOfMembers);

      var monthly, yearly;
      this.discountedPrice = ""
      this.gstPrice = ""

      var self = this;

      if (userCount < 1) {
        self.$swal({
          type: "warning",
          text: "Number of members cannot be less than 1"
        });
        this.numberOfMembers = 10;
        return;
      }

      var planCurrency = self.planCurrency;

      if (userCount <= 10) {
        if (planCurrency != "INR") {
          monthly = (userCount * 2).toFixed(0);
          yearly = (userCount * 2 * 9.6).toFixed(0);
        } else {
          monthly = (userCount * 2 * 50).toFixed(0);
          yearly = (userCount * 2 * 50 * 9.6).toFixed(0);
        }
      } else if (userCount > 10 && userCount <= 50) {
        if (planCurrency != "INR") {
          monthly = ((userCount - 10) * 1.5 + 20).toFixed(0);
          yearly = ((userCount - 10) * 14.4 + 192).toFixed(0);
        } else {
          monthly = ((userCount - 10) * 75 + 1000).toFixed(0);
          yearly = ((userCount - 10) * 720 + 9600).toFixed(0);
        }
      } else if (userCount > 50 && userCount <= 300) {
        if (planCurrency != "INR") {
          monthly = ((userCount - 50) * 1.48 + 80).toFixed(0);
          yearly = ((userCount - 50) * 14.208 + 768).toFixed(0);
        } else {
          monthly = ((userCount - 50) * 74 + 4000).toFixed(0);
          yearly = ((userCount - 50) * 710.4 + 38400).toFixed(0);
        }
      } else if (userCount > 300 && userCount <= 1000) {
        if (planCurrency != "INR") {
          monthly = ((userCount - 300) * 1.4 + 450).toFixed(0);
          yearly = ((userCount - 300) * 13.44 + 4320).toFixed(0);
        } else {
          monthly = ((userCount - 300) * 70 + 22500).toFixed(0);
          yearly = ((userCount - 300) * 672 + 216000).toFixed(0);
        }
      } else if (userCount > 1000) {
        if (planCurrency != "INR") {
          monthly = ((userCount - 1000) * 1.32 + 1430).toFixed(0);
          yearly = ((userCount - 1000) * 12.672 + 13728).toFixed(0);
        } else {
          monthly = ((userCount - 1000) * 66 + 71500).toFixed(0);
          yearly = ((userCount - 1000) * 633.6 + 686400).toFixed(0);
        }
      }

  
      if (this.planCycle == "Monthly") {

      if(typeof this.$store.getters.company.discount != "undefined"){

        var companyDiscount = this.$store.getters.company.discount

        var discount = Number(companyDiscount)*monthly/100

        this.planPrice = monthly

        this.discountedPrice = monthly - discount;

         if(this.companyData.country == "India"){
            this.gstPrice = 18*this.discountedPrice/100
         }

      
      }else{

          this.planPrice = monthly

          if(this.companyData.country == "India"){
            this.gstPrice = 18*this.planPrice/100
          }
      }

   
      } else {


      if(typeof this.$store.getters.company.discount != "undefined"){


        var companyDiscount = this.$store.getters.company.discount

        var discount = Number(companyDiscount)*yearly/100

        this.planPrice = yearly;

        this.discountedPrice = yearly - discount;

        if(this.companyData.country == "India"){
            this.gstPrice = 18*this.discountedPrice/100
        }

      
      }else{

          this.planPrice = yearly;

          if(this.companyData.country == "India"){
            this.gstPrice = 18*this.planPrice/100
          }
      }

      }
    },

    pay() {
      const self = this;
      self
        .$swal({
          text: "Are you sure?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "info",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirm"
        })
        .then(async result => {
          if (result.value) {
            self.afterUpdate = true;

            await self.$http
              .post(`${self.$store.state.endpoint}plans/make`, {
                userCount: Number(self.numberOfMembers),
                billCycle: self.planCycle,
                billCurrency: self.planCurrency
              })
              .then(response => {
                console.log("Razorpy key", self.$store.getters.razorkey);
                var options = {
                  //"key": "rzp_test_0aGQhzkfHRqeJk",
                  key: self.$store.getters.razorkey,
                  subscription_id: response.body.id,
                  name: "Regular.li",

                  // image: 'https://regular.li/img/logo.png',
                  image: logo,
                  description: "Payment of Subscription",
                  currency: self.planCurrency,
                  prefill: {
                    email: self.$store.getters.userDetails.email,
                    contact: self.$store.getters.userDetails.phone,
                    name: `${self.$store.getters.userDetails.firstName} ${self.$store.getters.userDetails.lastName}`
                  },
                  theme: {
                    color: "#1976D2"
                  }
                };

                var successCallback = function(success) {
                  // alert('payment_id: ' + success.razorpay_payment_id)
                  var orderId = success.razorpay_order_id;
                  var signature = success.razorpay_signature;

                  self.afterUpdate = false;

                  self.$swal({
                    type: "success",
                    text:
                      "Thank you for subscribing to Regular.li. Your account will be updated shortly."
                  });

                  fb.log("subscribe");
                };

                var cancelCallback = function(error) {
                  self.afterUpdate = false;
                  fb.log("payment_cancel");
                };

                RazorpayCheckout.on("payment.success", successCallback);
                RazorpayCheckout.on("payment.cancel", cancelCallback);
                RazorpayCheckout.open(options);
              })
              .catch(err => {
                console.log(err);

                self.afterUpdate = true;

                self.$http
                  .post(`${self.$store.state.endpoint}plans/make`, {
                    userCount: Number(self.numberOfMembers),
                    billCycle: self.planCycle,
                    billCurrency: self.planCurrency
                  })
                  .then(response => {
                    var options = {
                      key: self.$store.getters.razorkey,
                      subscription_id: response.body.id,
                      name: "Regular.li",

                      // image: 'https://regular.li/img/logo.png',
                      image: logo,
                      description: "Payment of Subscription",
                      currency: self.planCurrency,
                      prefill: {
                        email: self.$store.getters.userDetails.email,
                        contact: self.$store.getters.userDetails.phone,
                        name: `${self.$store.getters.userDetails.firstName} ${self.$store.getters.userDetails.lastName}`
                      },
                      theme: {
                        color: "#1976D2"
                      }
                    };

                    var successCallback = function(success) {
                      // alert('payment_id: ' + success.razorpay_payment_id)
                      var orderId = success.razorpay_order_id;
                      var signature = success.razorpay_signature;

                      self.afterUpdate = false;

                      fb.log("subscribe");

                      self.$swal({
                        type: "success",
                        text:
                          "Thank you for subscribing to Regular.li. Your account will be updated shortly."
                      });
                    };

                    var cancelCallback = function(error) {
                      self.afterUpdate = false;
                      fb.log("payment_cancel");
                    };

                    RazorpayCheckout.on("payment.success", successCallback);
                    RazorpayCheckout.on("payment.cancel", cancelCallback);
                    RazorpayCheckout.open(options);
                  })
                  .catch(err => {
                    self.afterUpdate = false;
                    //  console.log(err.body.error.error.description)

                    console.log(err.body.error.error);

                    if (typeof err.body.error.error == "undefined") {
                      self.$swal({
                        type: "warning",
                        text: err.body.error.message
                      });
                    } else {
                      self.$swal({
                        type: "warning",
                        text: err.body.error.error.description
                      });
                    }
                  });
              });
          }
        });
    },

    /* isExistPlan(val) {
      const pModule = this.planModule;


      for (const i in pModule) {
        if (pModule[i].name == val) {
          return true;
        }
      }
      return false;
    }, */

    autoDetectTimeZone() {
      this.companyData.tz.name = moment.tz.guess();
    },

    cancelSubscription() {
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to cancel your subscription?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
          const { company } = this.$store.getters;

          var self = this;

          self.afterUpdate = true;

          const planId = company.plan.id;

          self.$http
            .post(`${self.$store.state.endpoint}plans/${planId}/cancel`)
            .then(response => {
              self.afterUpdate = false;

              fb.log("cancel_subcription");
            });
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
.gps-btn {
  /* margin-left: 327px;
  z-index: 1;
  top: -35px; */
  margin-left: -190px;
  background: transparent !important;
  box-shadow: none !important;
}
@media only screen and (max-width: 600px) {
  .gps-btn {
    margin-left: -120px;
  }
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.company-save-btn {
  color: #ffffff;
  letter-spacing: 1px;
  margin-bottom: 20px;
  font-size: 16px;
}

.customBorder {
  border-style: solid;
  padding: 5px;
  border-radius: 4px;
}

.v-application--is-ltr .v-list-item__avatar:first-child {
  margin-right: 8px !important;
}

.v-list-item__subtitle,
.v-list-item__title {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
  overflow: auto;
  text-overflow: ellipsis !important;
  white-space: pre-line !important;
}

.customCenter {
  justify-content: center !important;
  flex-direction: row !important;
  text-align: center !important;
  align-items: center !important;
}

.flight-types {
  display: flex;
  max-width: 336px;
  width: 100%;
  position: relative;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  position: relative;
  z-index: 1;
  margin: 0 auto;
  font-size: 12px;
  border: 1px solid #fff;
  border-radius: 3px;
  color: #fff;
}
.flight-types > input {
  display: none;
}
.flight-types > input:checked + label {
  color: #3395de;
}
.flight-types > input:nth-of-type(1):checked ~ label:last-of-type:before {
  transform: translateX(calc(0% + 0px));
}
.flight-types > input:nth-of-type(2):checked ~ label:last-of-type:before {
  transform: translateX(calc(100% + 0px));
}
.flight-types > input:nth-of-type(3):checked ~ label:last-of-type:before {
  transform: translateX(calc(200% + 0px));
}
.flight-types label {
  flex: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.flight-types label:last-of-type:before {
  content: "";
  display: block;
  max-width: calc(33.3333333333% - 0px);
  margin: 0px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  transform: translateX(0);
}
.flight-types label {
  padding: 6px 3px;
  transition: color 250ms cubic-bezier(0, 0.95, 0.38, 0.98);
}
.flight-types label:before {
  background: #fff;
  transition: all 250ms cubic-bezier(0, 0.95, 0.38, 0.98);
}
.flight-types label:not(:last-child) {
  border-right: 1px solid #fff;
}

@media (min-width: 1200px) {
  .curFlex {
    flex: 0.2 !important;
  }
}

/* Landscape tablets and medium desktops */
@media (min-width: 992px) and (max-width: 1199px) {
  .curFlex {
    flex: 0.2 !important;
  }
}

/* Portrait tablets and small desktops */
@media (min-width: 768px) and (max-width: 991px) {
  .curFlex {
    flex: 2 !important;
  }
}

/* Landscape phones and portrait tablets */
@media (max-width: 767px) {
  .curFlex {
    flex: 2 !important;
  }
}

/* Portrait phones and smaller */
@media (max-width: 480px) {
  .curFlex {
    flex: 2 !important;
  }
}
</style>
